import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import SimpleAccordionContent from "../../common/SimpleAccordionContent";
import { getAllRows } from "../ReportElementHelper";

class CriminalActionsSecondarySources extends Component {
  state = {
    rows: [],
    savedResultID: "",
    internalID: "",
  };

  componentWillReceiveProps(nextProps) {
    const { internalID, savedResultID } = nextProps.additionalData;
    if (
      this.state.internalID !== internalID ||
      this.state.savedResultID !== savedResultID
    ) {
      this.setState({ internalID, savedResultID });
      this.loadData(nextProps);
    }
  }

  loadData = (props) => {
    const rows = [];
    let recCount = 0;
    const records = props.records ? props.records : _.get(
      props.reportData,
      "personReport.compReportResponse[0].individual[0].criminalRecords[0].criminal"
    );
    if (records !== undefined && records.length > 0) {
    if (records) {
      _.forEach(records, (record, aircraftIndex) => {
        const recs = [];
        getAllRows(record, recs, props, _.get(record, "$.display"));
        if (recs.length > 0) {
          rows.push(
            <Table.Row key={`criminal_sec_row_${aircraftIndex}`}>
              <Table.Cell>
                <Table>
                  <Table.Body>
                    <Table.Row>
                      <Table.HeaderCell colSpan={2} className="report-sub-section-header">
                        Record
                      </Table.HeaderCell>
                    </Table.Row>
                    {recs}
                  </Table.Body>
                </Table>
              </Table.Cell>
            </Table.Row>
          );
        }
      });
      recCount = rows.length;
    } else {
      rows.push(
        <Table.Row key={`no_recs_row`}>
          <Table.Cell colSpan={2}>No Records found</Table.Cell>
        </Table.Row>
      );
    }
  } else {
    rows.push(
      <Table.Row key={`no_recs_row`}>
        <Table.Cell colSpan={2}>No Records found</Table.Cell>
      </Table.Row>
    );
  }
    this.setState({ rows });
    props.updateItemCountBySection(props.sectionName, recCount);
  };

  render() {
    return (
      <SimpleAccordionContent
        {...this.props}
        name={"Criminal Actions Involving Subject - Secondary Sources"}
        rows={this.state.rows}
      />
    );
  }
}

export default CriminalActionsSecondarySources;



// WEBPACK FOOTER //
// ./src/components/reports/Platinum/CriminalActionsSecondarySources.js